export default function reload() {
  window.location.reload();
}
